import { createApp } from "vue";
import App from "./App.vue";
import "./styles/tailwind.css";

createApp(App).mount("#app");
